export const routes = [
  {
    path: '/cidade/:id/agenteTerritorial/:tab',
    component: () => import('./list'),
    name: 'agenteTerritorial.list',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/agenteTerritorial/:tab/:tabId',
    component: () => import('./insert'),
    name: 'agenteTerritorial.insert',
    meta: {
      requiresAuth: true
    }
  },
]
